import { createSlice } from '@reduxjs/toolkit'
import { merge } from 'components/util'
import GameConfig from './game-config-model'
import {
  CreateGameConfigAsync,
  DeleteGameConfigAsync,
  LoadGameConfigsAsync,
} from './gameConfig-thunk'
const initialState: gameConfigSliceState = {
  gameConfig: [],
  selected_gameConfig: '',
  is_loading_gameConfig: false,
  is_creating_gameConfig: false,
  is_deleting_gameConfig: false,
}
export interface gameConfigSliceState {
  gameConfig: GameConfig[]
  selected_gameConfig?: string
  is_loading_gameConfig: boolean
  is_creating_gameConfig: boolean
  is_deleting_gameConfig: boolean
}
export const gameConfigSlice = createSlice({
  name: 'gameConfig',
  initialState,
  reducers: {
    setSelectedgameConfig: (state, action) => {
      state.selected_gameConfig = action.payload
    },
    clearStategameConfig: (state) => {
      state.gameConfig = []
      state.is_loading_gameConfig = false
      state.is_creating_gameConfig = false
      state.is_deleting_gameConfig = false
    },
    mergegameConfig: (state, action) => {
      if (action.payload) {
        let payload: any = action.payload
        if (payload?.data) {
          if (!Array.isArray(payload.data)) {
            state.selected_gameConfig = payload?.data?.id
            payload = [payload.data]
          } else {
            payload = payload.data
          }
          state.gameConfig = merge(state.gameConfig, payload) as any
        }
      }
    },

    add_gameConfig: (state, action) => {
      if (action.payload) {
        state.gameConfig = [...state.gameConfig, action.payload]
      }
    },
    set_gameConfig: (state, action) => {
      let { key, value, id } = action.payload
      state.gameConfig = state.gameConfig.map((item) => {
        if (item && item.id === id) {
          return {
            ...item,
            [key]: value,
          }
        }
        return item
      })
    },
  },
  extraReducers: (builder) => {
    builder.addCase('LOGOUT', () => {
      return { ...initialState }
    })

    builder.addCase(LoadGameConfigsAsync.pending, (state) => {
      state.is_loading_gameConfig = true
    })
    builder.addCase(LoadGameConfigsAsync.fulfilled, (state, action) => {
      state.is_loading_gameConfig = false
      if (action.payload) {
        state.gameConfig = action.payload
      }
    })
    builder.addCase(LoadGameConfigsAsync.rejected, (state) => {
      state.is_loading_gameConfig = false
    })
    builder.addCase(CreateGameConfigAsync.pending, (state) => {
      state.is_creating_gameConfig = true
    })
    builder.addCase(CreateGameConfigAsync.fulfilled, (state) => {
      state.is_creating_gameConfig = false
    })
    builder.addCase(CreateGameConfigAsync.rejected, (state) => {
      state.is_creating_gameConfig = false
    })
    builder.addCase(DeleteGameConfigAsync.pending, (state) => {
      state.is_deleting_gameConfig = true
    })
    builder.addCase(DeleteGameConfigAsync.fulfilled, (state, action) => {
      state.is_deleting_gameConfig = false
      if (state.gameConfig) {
        state.gameConfig = state.gameConfig.filter(
          (x) => action.payload.id !== x.id,
        )
      }
    })
    builder.addCase(DeleteGameConfigAsync.rejected, (state) => {
      state.is_deleting_gameConfig = false
    })
  },
})

export const {
  clearStategameConfig,
  setSelectedgameConfig,
  set_gameConfig,
  mergegameConfig,
  add_gameConfig,
} = gameConfigSlice.actions

export const get_gameConfig =
  (id?: string) =>
  (state: {
    gameConfig: {
      gameConfig: GameConfig[]
    }
  }): GameConfig | null => {
    let temp = state?.gameConfig?.gameConfig?.find((v) => v.id === id)
    if (temp) {
      return temp
    }
    return state?.gameConfig?.gameConfig[0] || null
  }
export const get_selected_gameConfig = (state: {
  gameConfig: gameConfigSliceState
}): GameConfig | null => {
  let id = state?.gameConfig?.selected_gameConfig
  let temp = state?.gameConfig?.gameConfig?.find((v) => v.id === id)
  if (temp) {
    return temp
  }
  return null
}
export const get_all_gameConfig = (state: {
  gameConfig: {
    gameConfig: GameConfig[]
  }
}): GameConfig[] => {
  let temp = state?.gameConfig?.gameConfig
  if (temp) {
    return temp.filter((x) => !x.deleted)
  }
  return []
}
export const is_gameConfig_busy = (state: {
  gameConfig: gameConfigSliceState
}) => {
  return (
    state?.gameConfig.is_deleting_gameConfig ||
    state?.gameConfig.is_loading_gameConfig ||
    state?.gameConfig.is_creating_gameConfig
  )
}
export const is_deleting_gameConfig_busy = (state: {
  gameConfig: gameConfigSliceState
}) => {
  return state?.gameConfig.is_deleting_gameConfig
}
export const is_loading_gameConfig_busy = (state: {
  gameConfig: gameConfigSliceState
}) => {
  return state?.gameConfig.is_loading_gameConfig
}
export const is_creating_gameConfig_busy = (state: {
  gameConfig: gameConfigSliceState
}) => {
  return state?.gameConfig.is_creating_gameConfig
}

export default gameConfigSlice.reducer
